import { products, site } from "@/data/store";

export const getProduct = (slug) => products.find((p) => p.slug === slug);

export const getVariant = (product, id) =>
  product.variants.find((v) => v.id === id) || product.variants[0];

export const formatPrice = (price) =>
  `${site.currencySymbol}${Number.isInteger(price) ? price : price.toFixed(2)}`;
